import React, { useState } from 'react'
import { useQuery } from 'urql'
import { REPOSITORY_NAME } from './config'
import Loading from './components/Loading'
import './App.css'
import Post from './components/Post'
import Error from './components/Error'

const App: React.FC = () => {
  const [visiblePostNumber, setVisiblePostNumber] = useState(-1)
  const [result] = useQuery({
    query: `{
      viewer {
        avatarUrl
        login
        url
        repository(name: "${REPOSITORY_NAME}") {
          issues(last: 10, states: OPEN) {
            nodes {
              title
              number
            }
          }
        }
      }
    }`
  })
  const { fetching, data, error } = result

  if (fetching) {
    return <Loading />
  }

  if (error) {
    return <Error msg={error.message} />
  }

  const {
    viewer: {
      avatarUrl,
      url,
      repository: {
        issues: { nodes }
      }
    }
  } = data

  return (
    <>
      <div className="header">
        <h1>Favor</h1>
        <a href={url}>
          <img src={avatarUrl} className="avatar" alt="avatar" />
        </a>
      </div>
      <div className="cards">
        {nodes.map(({ number, title }: any) => (
          <div
            className="card"
            key={number}
            onClick={() => setVisiblePostNumber(number)}
          >
            <h5 className="card-header">{title}</h5>
          </div>
        ))}
      </div>
      {visiblePostNumber !== -1 && (
        <Post
          number={visiblePostNumber}
          onClick={() => setVisiblePostNumber(-1)}
        />
      )}
    </>
  )
}

export default App
